import * as x from "react";
import { i as b, E as S, x as u, r as C, c as w } from "../createReactComponent-58f9bea8.mjs";
import { n as m } from "../property-9daa16cd.mjs";
import { r as h } from "../state-7560d4dc.mjs";
import { e as y } from "../query-d94c86d2.mjs";
import { r as E } from "../dropdown-3820c146.mjs";
import { r as _ } from "../menu-item-65dd9fa4.mjs";
import { r as $ } from "../menu-item-group-76fb1396.mjs";
import { r as D } from "../menu-3df3d7c3.mjs";
import { r as F } from "../pill-a1831740.mjs";
import { r as L } from "../date-picker-8cb0ed99.mjs";
import "../base-e16d29d8.mjs";
import "../class-map-2994e95e.mjs";
import "../tooltip-cb602d1f.mjs";
import "../button-7600b6ca.mjs";
import "../icon-c572aa57.mjs";
import "../icon-button-a9d2a2d1.mjs";
import "../slot-controller-fa97ce97.mjs";
import "../checkbox-46b40c6a.mjs";
import "../radio-8b0e9514.mjs";
import "../if-defined-47693dfa.mjs";
import "../live-6c85dd15.mjs";
import "../purify.es-39f8036b.mjs";
import "../pill-group-834f5519.mjs";
import "../utils-cf5bbdd1.mjs";
import "../style-map-c3339321.mjs";
import "../query-async-a940115b.mjs";
const A = b`
  :host .filter {
    display: flex;
    flex-wrap: wrap;
    gap: var(--exo-spacing-x-small);
  }
  :host .filter__date {
    max-width: var(--exo-size-2);
  }
  :host .filter__dropdown {
    width: var(--exo-size-2);
  }
  :host .filter__dropdown-empty {
    padding: var(--exo-spacing-x-small) var(--exo-spacing-standard);
  }
`;
var M = Object.defineProperty, I = Object.getOwnPropertyDescriptor, l = (n, e, t, r) => {
  for (var a, i = r > 1 ? void 0 : r ? I(e, t) : e, o = n.length - 1; o >= 0; o--)
    (a = n[o]) && (i = (r ? a(e, t, i) : a(i)) || i);
  return r && i && M(e, t, i), i;
};
function g(n, e) {
  return n.getAttribute(e) || n[e] || null;
}
class s extends S {
  constructor() {
    super(...arguments), this.dateFilter = !1, this.showSelectedCategory = !1, this.emptyValidationMessage = "No data", this.filterLabel = "Filter", this.data = [], this.defaultValues = [], this.isDirty = !1, this.isFirstUpdate = !0;
  }
  firstUpdated() {
    this.setInitialData(), this.defaultValues.forEach((e) => this.updateCategoriesOnSelection(e));
  }
  setInitialData() {
    const e = Array.from(this.getElementsByTagName("ex-menu-item")).map((r) => {
      var a;
      return { category: g(r, "category"), label: ((a = r.textContent) == null ? void 0 : a.trim()) || "", value: g(r, "value") };
    }), t = [];
    e.forEach((r, a) => {
      t.length === 0 || r.category !== e[a - 1].category ? t.push(function(i) {
        const o = { label: i.label, value: i.value || i.label, selected: !1 }, d = [];
        return o.label === "" && o.value === "" || d.push(o), { category: i.category, items: d, selected: i.selected };
      }({ ...r, selected: !!r.category && this.defaultValues.includes(r.category) })) : t[t.length - 1].items.push(function(i) {
        return { label: i.label, value: i.value || i.label, selected: !1 };
      }(r));
    }), this.data = t;
  }
  removeOpenAttributeFromDropdown() {
    var t;
    const e = (t = this.shadowRoot) == null ? void 0 : t.querySelectorAll(".filter__pill");
    e == null || e.forEach((r) => {
      const a = r.querySelector("ex-dropdown");
      a == null || a.removeAttribute("auto-open");
      const i = a == null ? void 0 : a.querySelector("ex-pill");
      i == null || i.removeAttribute("selected");
    });
  }
  getFilter() {
    const e = this.getMenuItems();
    return e.length > 0 ? u`<div class="filter__dropdown">
        <ex-dropdown
          icon="plus"
          text="${this.filterLabel}"
          flavor="branded"
          size="default"
          type="secondary"
          @open-dropdown=${this.removeOpenAttributeFromDropdown}
        >
          <ex-menu
            variant="action"
            id="category__menu"
            @onSelect=${this.onCategorySelect}
          >
            <ex-menu-item-group> ${e} </ex-menu-item-group>
          </ex-menu>
        </ex-dropdown>
      </div>` : u`<div class="filter__dropdown">
      <ex-dropdown
        icon="plus"
        text="${this.filterLabel}"
        flavor="branded"
        size="default"
        type="secondary"
        @open-dropdown=${this.removeOpenAttributeFromDropdown}
      >
        <ex-menu variant="action" id="category__menu">
          <ex-menu-item-group>
            <div class="filter__dropdown-empty">
              ${this.emptyValidationMessage}
            </div>
          </ex-menu-item-group>
        </ex-menu>
      </ex-dropdown>
    </div>`;
  }
  getMenuItems() {
    return this.data.map((e) => {
      if (e.selected) {
        if (this.showSelectedCategory && !this.isDirty)
          return u`<ex-menu-item
            variant="checkbox"
            value="${e.category}"
            selected
            >${e.category}</ex-menu-item
          >`;
      } else {
        if (this.showSelectedCategory && !this.isDirty)
          return u`<ex-menu-item
            variant="checkbox"
            value="${e.category}"
            >${e.category}</ex-menu-item
          >`;
        if (!this.showSelectedCategory)
          return u`<ex-menu-item>${e.category}</ex-menu-item>`;
      }
      return null;
    });
  }
  getSubMenuItems() {
    const { items: e } = this.data[this.subCategorySelectedIndex];
    let t = "";
    return e.forEach((r) => {
      t += `<ex-menu-item variant="checkbox" value="${r.value}">${r.label}</ex-menu-item>`;
    }), { subCategoryItems: t, items: e };
  }
  getPillFilter(e) {
    const t = document.createElement("div");
    t.classList.add("filter__pill"), t.setAttribute("data-category", this.data[this.subCategorySelectedIndex].category);
    const r = `
      <ex-dropdown icon="plus" flavor="branded" size="default" type="secondary" use-display="" >
        <div slot="anchor">
          <ex-pill interactive removable color="gray">${this.data[this.subCategorySelectedIndex].category.trim()}</ex-pill>
        </div>
        <ex-menu
          variant="action"
          class="subcategory__menu"
        >
          <ex-menu-item-group>${e}</ex-menu-item-group>
        </ex-menu>
      </ex-dropdown>
    `;
    return t.innerHTML = r, t.addEventListener("onSelect", (a) => this.onSubCategorySelect(a)), t.addEventListener("onRemove", (a) => this.removeCategory(a)), setTimeout(() => function(a) {
      document.addEventListener("click", (i) => {
        const o = i.target;
        if (i != null && i.target && o.nodeName !== "EX-MENU-ITEM-GROUP" && o.nodeName !== "EX-FILTER") {
          const d = a.querySelector("ex-dropdown");
          d && d.removeAttribute("auto-open");
          const p = a.querySelector("ex-pill");
          p && p.removeAttribute("selected");
        }
      });
    }(t)), t;
  }
  getPill() {
    const e = document.createElement("div");
    e.classList.add("filter__pill"), e.setAttribute("data-category", this.data[this.subCategorySelectedIndex].category);
    const t = `
          <ex-pill interactive removable color="gray">${this.data[this.subCategorySelectedIndex].category.trim()}</ex-pill>`;
    return e.innerHTML = t, e.addEventListener("onSelect", (r) => this.onSubCategorySelect(r)), e.addEventListener("onRemove", (r) => this.removeCategory(r)), e;
  }
  updateFilterPills() {
    const { subCategoryItems: e } = this.getSubMenuItems();
    return e ? this.getPillFilter(e) : this.getPill();
  }
  onCategorySelect(e) {
    var t;
    if (this.isDirty = !0, this.showSelectedCategory)
      this.updateSelectedCategories(e.detail);
    else {
      this.updateCategoriesOnSelection(e.detail.value[0]), this.categoryMenu.innerHTML = this.updateFilterList();
      const r = `.filter__pill[data-category='${e.detail.value[0]}']`, a = (t = this.filterEl) == null ? void 0 : t.querySelector(r), i = a == null ? void 0 : a.querySelector("ex-dropdown");
      i && i.setAttribute("auto-open", "");
      const o = i == null ? void 0 : i.querySelector("ex-pill");
      o && o.setAttribute("selected", "");
    }
  }
  async updateCategoriesOnSelection(e) {
    this.isFirstUpdate && this.defaultValues.length > 0 && (await this.updateComplete, this.isFirstUpdate = !1), this.updateDataAfterSelection(e), this.filterEl.insertBefore(this.updateFilterPills(), this.filterDropdownEl), this.dispatchOnChangeEvent({ category: e, newCategory: !0 });
  }
  updateSelectedCategories(e) {
    var t;
    if (e.checked)
      this.updateCategoriesOnSelection(e.checked);
    else if (e.unchecked) {
      this.updateDataAfterDeSelection(e.unchecked);
      const r = `.filter__pill[data-category='${e.unchecked}']`, a = (t = this.filterEl) == null ? void 0 : t.querySelector(r);
      this.filterEl.removeChild(a), this.dispatchOnChangeEvent({ category: e.unchecked, filters: [], newCategory: !1 });
    }
  }
  onSubCategorySelect(e) {
    var i, o, d, p;
    const t = g(e.currentTarget, "data-category"), r = (o = (i = e.detail) == null ? void 0 : i.value) == null ? void 0 : o.map((c) => ({ label: c, value: c, selected: !0 })), a = (p = (d = e.currentTarget) == null ? void 0 : d.getElementsByTagName("ex-dropdown")[0]) == null ? void 0 : p.getElementsByTagName("ex-pill")[0];
    a && (e.detail.value.length > 0 ? a.innerHTML = `${t}: ${r.map((c) => c.label).join(", ")}` : a.innerHTML = t, this.data[this.subCategorySelectedIndex].items.forEach((c) => {
      c.selected = !1;
    }), e.detail.value.forEach((c) => {
      const f = this.data[this.subCategorySelectedIndex].items.find((v) => v.value === c);
      f && (f.selected = !0);
    }), this.dispatchOnChangeEvent({ category: t, filters: r }));
  }
  removeCategory(e) {
    var r, a;
    const t = g(e.currentTarget, "data-category") || "default-category";
    if (this.showSelectedCategory) {
      this.updateDataAfterDeSelection(t);
      const i = `ex-menu-item[value='${t}']`, o = (a = (r = this.categoryMenu.querySelector("ex-menu-item-group")) == null ? void 0 : r.shadowRoot) == null ? void 0 : a.querySelector(i);
      o == null || o.removeAttribute("selected"), e.currentTarget.outerHTML = "", this.dispatchOnChangeEvent({ category: t, filters: [], newCategory: !1 });
    } else
      this.updateDataAfterDeSelection(t), this.categoryMenu.innerHTML = this.updateFilterList(), e.currentTarget.outerHTML = "", this.dispatchOnChangeEvent({ category: t, filters: [], newCategory: !1 });
  }
  updateDataAfterDeSelection(e) {
    const t = e;
    this.data.forEach((r) => {
      r.category === t && (r.selected = !1);
    });
  }
  updateDataAfterSelection(e) {
    const t = e;
    this.data.forEach((r, a) => {
      r.category === t && (r.selected = !0, this.subCategorySelectedIndex = a);
    });
  }
  getUpdatedCategory(e) {
    return this.showSelectedCategory ? `<ex-menu-item variant="checkbox">${e}</ex-menu-item>` : `<ex-menu-item >${e}</ex-menu-item>`;
  }
  updateFilterList() {
    let e = !0, t = "<ex-menu-item-group>";
    return this.data.forEach((r) => {
      r.selected || (t += this.getUpdatedCategory(r.category), e = !1);
    }), e && (t += `<div class="filter__dropdown-empty">${this.emptyValidationMessage}</div>`), t += "</ex-menu-item-group>", t;
  }
  getDate() {
    let e = u``;
    return this.dateFilter && (e = u`<div class="filter__date">
        <ex-date-picker placeholder="mm-dd-yyyy" value=""> </ex-date-picker>
      </div> `), e;
  }
  dispatchOnChangeEvent(e) {
    this.dispatchCustomEvent("on-change", e);
  }
  render() {
    return u`<div class="filter">
      ${this.getDate()} ${this.getFilter()}
    </div> `;
  }
}
s.styles = A, l([m({ type: Boolean })], s.prototype, "dateFilter", 2), l([m({ type: Boolean })], s.prototype, "showSelectedCategory", 2), l([m({ type: String })], s.prototype, "emptyValidationMessage", 2), l([m({ type: String })], s.prototype, "filterLabel", 2), l([h()], s.prototype, "data", 2), l([h()], s.prototype, "subCategorySelectedIndex", 2), l([m({ type: Array })], s.prototype, "defaultValues", 2), l([y("#category__menu")], s.prototype, "categoryMenu", 2), l([y(".filter")], s.prototype, "filterEl", 2), l([y(".filter__dropdown")], s.prototype, "filterDropdownEl", 2), l([h()], s.prototype, "isDirty", 2), l([h()], s.prototype, "isFirstUpdate", 2);
const T = (n = "") => {
  C("ex-filter", s, n), E(n), _(n), $(n), D(n), F(n), L(n);
}, se = w({ tagName: "ex-filter", elementClass: s, react: x, events: { onChange: "on-change" }, displayName: "ExFilter", registerWebComponent: T });
export {
  se as ExFilter,
  T as register
};
